import { Dispatch, SetStateAction } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { ISaveOrganization } from "../../interfaces/services";
import { EtyOrganization } from "../../interfaces/entities";
import { IOrganizationForTree, ISelectedData } from "../../interfaces/tree";
import { IUserData } from "../../interfaces/forms";

import useToast from "../useToast";

import { saveOrganization } from "../../services/organizations";

import useSaveUsers from "../users/useSaveUsers";

export interface IPayload {
    payload: ISaveOrganization;
    usersPayload: IUserData[];
    setIsProcessing: Dispatch<SetStateAction<boolean>>;
    selected: ISelectedData | null;
    setSelected: Dispatch<SetStateAction<ISelectedData | null>>;
};

export interface IResponse {
    error?: string;
    message: string;
    statusCode: number;
    data: EtyOrganization;
};

const useSaveOrganization = () => {
    const queryClient = useQueryClient();

    const { addToast } = useToast();

    const { mutate: saveUsers } = useSaveUsers();

    const mutationFn = async (data: IPayload): Promise<IResponse> => {
        return await saveOrganization(data.payload);
    };

    return useMutation({
        mutationFn,
        onSuccess: (response: IResponse, variables: IPayload) => {
            if (response?.statusCode === 200) {
                // addToast({
                //     type: 'success',
                //     title: 'Organization saved successfully.',
                // });

                if (variables.selected) {
                    variables.setSelected({
                        id: response.data.id,
                        level: 0,
                        data: {
                            ...(variables.selected.data as IOrganizationForTree),
                            id: response.data.id,
                            name: response.data.name,
                            status: response.data.status,
                            status_update: response.data.status_update,
                        }
                    });
                };

                queryClient.invalidateQueries({ queryKey: ['organizations_tree'] });

                saveUsers({
                    payload: variables.usersPayload,
                    setIsProcessing: variables.setIsProcessing
                });
            };
        },
        onError: (error: IResponse, variables: IPayload) => {
            addToast({
                type: 'error',
                title: 'Error occured',
                message: error.message
            });
        },
        onSettled: (data: IResponse | undefined, error: IResponse | null, variables: IPayload) => {
            variables.setIsProcessing(false);
        },
    });
};

export default useSaveOrganization;